import PrettyNum from '@ebiz/pretty-num';
import Utils from '../../utils/utils';

export default class OutputRangeOption {
  value;
  range;
  tueIoutMax;
  displayValue;

  constructor(textRange, tueIoutMax) {
    let valueRange = [];
    if (textRange && textRange !== '') {
      valueRange = textRange
        .match(/-?\d+.?\d*[m]?/g) // There should be either 1 or 2 values (with possible decimals) in the output range param.  We are assuming it's in [value]m format.
        .map((valueOption) => {
          if (valueOption.charAt(valueOption.length - 1) === 'V') {
            valueOption = valueOption.slice(0, -1);
          }
          return PrettyNum.userEntryToNumber(valueOption, NaN);
        });
    }
    const displayValue = valueRange.length === 1 ? `0mA to ${textRange}` : textRange;
    this.value = textRange; // text - this is what will show in the hash
    this.range = valueRange; // in Amps
    this.tueIoutMax = tueIoutMax;
    this.displayValue = displayValue; // this is what will display in the selection box
  }

  get absoluteSum() {
    return this.range
      .filter((value) => Utils.isNumeric(value))
      .map((value) => Math.abs(value))
      .reduce((accumulator, currentValue) => accumulator + currentValue);
  }
}
